import { useCallback } from 'react';
import { Wallet } from '@types';

function useHasConnectedWallet() {
  return useCallback((wallets?: Wallet[]) => {
    const isAnyConnected = (wallet: Wallet) => wallet.active;
    return wallets?.some(isAnyConnected);
  }, []);
}

export default useHasConnectedWallet;
